import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/skeleton.css';
import 'vuetify/styles'; // Importa os estilos do Vuetify
import { createVuetify } from 'vuetify'; // Importa a função de criação do Vuetify
import { createMetaManager } from 'vue-meta';
import { createI18n } from 'vue-i18n';
import { createHead } from '@vueuse/head';
import ptBR from './locales/pt-br.json';
import en from './locales/en.json';

// Locale detection: localStorage → navigator.language → pt-BR default
function detectLocale() {
  const stored = localStorage.getItem('flipmemo_lang');
  if (stored) return stored;
  const locale = navigator.language?.startsWith('pt') ? 'pt-BR' : 'en';
  localStorage.setItem('flipmemo_lang', locale);
  return locale;
}

const locale = detectLocale();

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'pt-BR',
  messages: {
    'pt-BR': ptBR,
    en,
  },
  missing: (locale, key) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[i18n] Missing key "${key}" for locale "${locale}"`);
    }
    return key;
  },
});

const app = createApp(App);

// Usa o Vue Router e Vuex (se necessário)
app.use(router);
app.use(store);
app.use(createMetaManager());
app.use(i18n);

const head = createHead();
app.use(head);

const vuetify = createVuetify();
app.use(vuetify);
app.mount('#app');
